import React from 'react';

const ContactForm = () => {
  return (
    <div className='contact-form-section-container d-flex flex-column' id='contact'>
      <h1>
        <span>Curiosity,</span>
        <br />
        piqued.
      </h1>
      <form>
        <div className='email-input d-flex'>
          <input type='email' name='email' placeholder='Your email' />
          <button type='submit'>Send</button>
        </div>
      </form>
      <p>
        contact us to be the first to know about various collection launches, promotions, and more.
      </p>
    </div>
  );
};

export default ContactForm;